import { render } from "./MarketingSurveyAreasTeamPage.vue?vue&type=template&id=c6e278d6"
import script from "./MarketingSurveyAreasTeamPage.vue?vue&type=script&lang=js"
export * from "./MarketingSurveyAreasTeamPage.vue?vue&type=script&lang=js"

import exportComponent from "F:\\omar pos 2\\pos_administration_platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__